import type { ReactNode } from 'react'

import { ConfirmDialog } from '@/components/molecules/confirm-dialog.molecule'
import type { OrganizationMember } from '@/components/org-settings/members/members.interface'

interface RemoveMemberDialogProps {
  member: OrganizationMember | null
  onClose: () => void
  onConfirm: () => Promise<void>
}

export const RemoveMemberDialog: React.FC<RemoveMemberDialogProps> = ({
  member,
  onClose,
  onConfirm,
}): ReactNode => (
  <ConfirmDialog
    isOpen={member !== null}
    onOpenChange={(isOpen) => !isOpen && onClose()}
    title="Remove Member"
    description={`Are you sure you want to remove ${member?.email ?? 'this member'} from the organization?`}
    confirmLabel="Remove"
    onConfirm={onConfirm}
    variant="destructive"
  />
)

RemoveMemberDialog.displayName = 'RemoveMemberDialog'
